import React from 'react';
import {useSelector} from 'react-redux';
import {ScreenSelector} from '../../hooks/ScreenSelector';
import {Navbar} from './Navbar';
import {Sidebar} from './Sidebar';
import {Footer} from './Footer';

export const HomeScreen = () => {
    const sidebarCollapsed = useSelector(state => state.ui.sidebar);
    const ml = sidebarCollapsed
        ? 'ml-0 sm:ml-[60px]'
        : 'ml-0 sm:ml-[240px]';


    return (
        <div className="min-h-screen bg-slate-50">
            <Navbar/>
            <Sidebar/>

            <main
                className={`${ml} pt-[5px] min-h-[calc(100svh-64px)] flex flex-col transition-[margin] duration-200`}
            >
                <div className="flex-1 p-6 min-h-0">
                    <ScreenSelector />
                </div>
                <Footer />
            </main>

        </div>

    );
};